export default __webpack_public_path__ + "static/media/stake.de2f0704.svg";